<template>
  <div class="content">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>加盟</el-breadcrumb-item>
        <el-breadcrumb-item>核销中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card style="margin-top: 20px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="商品名称"
                      prop="name">
          <el-input v-model="query.product_keyword"
                    placeholder="输入商品名称"
                    @input="getList(query)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="ref_type">
          <el-select v-model="query.product_types"
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="getList(query)">
            <el-option v-for="item in filter.refTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邀请赠送"
                      prop="invite_present_status">
          <el-select v-model="query.invite_present_status"
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="handleFilterChange">
            <el-option label="未赠送"
                       :value="0"></el-option>
            <el-option label="已赠送"
                       :value="1"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <TableTittle :tittle="TableName"></TableTittle>
      </div>
      <el-table :data="tableData"
                :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
                :cell-style="{ textAlign: 'center', fontSize: '13px' }"
                border>
        <el-table-column type="index"
                         label="序号"
                         width="64"
                         align="center">
        </el-table-column>
        <el-table-column prop="code_product_name"
                         label="订单号"
                         width="160"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatOpenCourseCode(scope.row.task_title) }}
          </template>
        </el-table-column>
        <el-table-column prop="code_product_name"
                         label="商品名称"
                         width="320"
                         show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="code_product_type"
                         width="200"
                         label="商品类型">
          <template slot-scope="scope">
            <span v-show="scope.row.code_product_type == '1'">课程</span>
            <span v-show="scope.row.code_product_type == '2'">题库</span>
            <span v-show="scope.row.code_product_type == '3'">专栏</span>
            <span v-show="scope.row.code_product_type == '4'">资料</span>
          </template>
        </el-table-column>
        <el-table-column prop="invite_present_status"
                         label="邀请赠送"
                         width="110">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.invite_present_status) === 1 ? 'success' : 'info'"
                    size="mini">
              {{ Number(scope.row.invite_present_status) === 1 ? '已赠送' : '未赠送' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="code_count_total"
                         label="核销进度（已核销/总数）"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.code_count_exchange_finish}} / {{scope.row.code_count_total}}
          </template>
        </el-table-column>
        <el-table-column label="有效期"
                         min-width="300"
                         align="center">
          <template slot-scope="scope">
            <span>{{$moment(scope.row.code_start_time
).format('YYYY-MM-DD HH:mm')}} 至 {{$moment(scope.row.code_end_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time"
                         label="创建时间"
                         width="200">
          <template slot-scope="scope">
            {{ scope.row.create_time | dateFormat("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         min-width="200"
                         label="操作"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="download(scope.row)">下载</el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="handleContion(scope.row)">核销明细</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"></el-pagination>
      </div>
    </el-card>

    <serviceCondition :visible="conditonDialog"
                      :editRow="editRow"
                      @close="conditonDialog=false"></serviceCondition>
  </div>
</template>

<script>
import { adminUrl } from '../../../utils/helper'
import { startProductCodeTaskList } from '@/request/api'
import TableTittle from '../../../components/TableTittle/TableTittle.vue'
import serviceCondition from '../../../components/DialogComponents/warrant/serviceCondition.vue'
export default {
  components: {
    TableTittle,
    serviceCondition,
  },
  data() {
    return {
      TableName: '核销列表',
      submitmethods: 'add',
      filter: {
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
        ],
      },
      form: {},
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        handle_task_types: 2,
        invite_present_status: '',
      },
      pageTotal: 0,
      tableData: [],
      orderDialogVisible: false,
      selectedProduct: null,
      editRow: null,
      conditonDialog: false,
    }
  },

  mounted() {
    this.getList(this.query)
  },
  methods: {
    formatOpenCourseCode(code) {
      // code 格式示例: "加盟商开课码（订单号：260518543579）"
      if (!code) return '-'

      // 匹配括号内的数字
      const match = code.match(/订单号：(\d+)/)
      return match ? match[1] : code
    },
    handleContion(row) {
      this.editRow = row
      this.conditonDialog = true
    },
    async download(row) {
      let str = adminUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/back/product/startProductCode/task/export`,
        method: 'get',
        params: { start_code_task_id: row.id },
      })
      if (res) {
        this.$message.success(`导出成功`)
        window.open(res.data.url)
      }
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList(this.query)
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList(this.query)
    },
    handleFilterChange() {
      this.query.pageIndex = 1
      this.getList(this.query)
    },

    async getList(query) {
      const res = await startProductCodeTaskList(query)
      if (res.code === 0) {
        this.tableData = (res.data && res.data.list) || []
        this.pageTotal = (res.data && res.data.count) || 0
      }
    },

    handleCreatOrder(item) {
      this.selectedProduct = item
      this.orderDialogVisible = true
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
}
.card-header {
  display: flex;
  justify-content: space-between;
  .el-button {
    height: 35px;
    line-height: 10px;
  }
}
.block {
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}
</style>
